// extracted by mini-css-extract-plugin
module.exports = {"player-wrapper":"ProjectDetailsVideo_player-wrapper__pPo03","react-player":"ProjectDetailsVideo_react-player__8k1Qs"};